/**
 * Common - Module - Add to cart
 */

// Imports
import GlobalVars from '../GlobalVars';
import {
  addItem,
  readItemCookie,
  readQuantityOfItemCookie,
} from '../Cart';
import {
  cartItemQtyReachLimitEventName,
  cartItemQtyBelowLimitEventName,
} from '../../common/Events';

const maximumQuantityReachedProductIds = [];

/*
 * Redirect iser to the cart
 */
function goToCart() {
  document.location.href = `/ecomBag.aspx?c=${GlobalVars.C}&l=${GlobalVars.L}`;
}

function cartProductsQuantityLimiter(event, productId, itemQuantity, maximumAuthorizedQuantity) {
  const productIndex = maximumQuantityReachedProductIds.indexOf(productId);
  const isMaximumQantityReached = itemQuantity >= maximumAuthorizedQuantity;

  /* Item quantity just reach limitation */
  if (isMaximumQantityReached && productIndex === -1) {
    maximumQuantityReachedProductIds.push(productId);
    $(event.target).trigger(cartItemQtyReachLimitEventName, productId);
  }

  /* Item quantity just go below limitation */
  if (!isMaximumQantityReached && productIndex !== -1) {
    maximumQuantityReachedProductIds.splice(productIndex, 1);
    $(event.target).trigger(cartItemQtyBelowLimitEventName, productId);
  }
}

function isProductAllowedToAddInCart(productSku, maximumAuthorizedQuantity) {
  const productCookie = readItemCookie(productSku);
  const isProductAlreadyInCart = typeof productCookie !== 'undefined';

  if (!isProductAlreadyInCart) {
    return true;
  }

  return readQuantityOfItemCookie(productCookie) < maximumAuthorizedQuantity;
}

function getUpdatedQuantity(productSku, addedQuantity) {
  const productCookie = readItemCookie(productSku);

  if (typeof productCookie === 'undefined') {
    return addedQuantity;
  }

  return readQuantityOfItemCookie(productCookie);
}

 /**
 * Add given product to cart
 *
 * @params productSku {String} Product SKU
 * @params productId {Integer} Id of the product (eg. ID_Article)
 * @params quantityToAdd {Integer} Quantity of product to be added to existing cart (default value : 1)
 *
 * @return {Boolean} true if the product has been added to cart successfully.
 */
function addProductToCart({
  productSku,
  productId,
  maximumAuthorizedQuantity,
  quantityToAdd = 1,
  onCartUpdated,
  triggerAddItemToCartEvent = false
}) {
  if (isProductAllowedToAddInCart(productSku, maximumAuthorizedQuantity)) {
    // Add the item to the cart
    addItem({
      sku: productSku,
      id: productId,
      title: '',
      price: '',
      quantity: quantityToAdd,
    }, !triggerAddItemToCartEvent);

    /*
     * If item already exist in cart, add its previous qantity
     */
    const updatedQuantity = getUpdatedQuantity(productSku, quantityToAdd);

    onCartUpdated([productId, updatedQuantity]);

    return true;
  }

  return false;
}

// Named exports - Functions
export {
  goToCart,
  addProductToCart,
  cartProductsQuantityLimiter,
  isProductAllowedToAddInCart
};



// WEBPACK FOOTER //
// ./js/common/modules/add-to-cart.js